import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=8bf36baa&"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js&"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports